import UploadIdentityCardButton from './UploadIdentityCardButton';

export default UploadIdentityCardButton;
